import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconArrayObjects(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M3 4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H5v14h3a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1V4ZM21 20a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h3V5h-3a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v16Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.414 6.586c-.707-.707-2.121-.707-2.828 0l-4 4c-.707.707-.707 2.121 0 2.828l4 4c.707.707 2.121.707 2.828 0l4-4c.707-.707.707-2.121 0-2.828l-4-4ZM8 12l4-4 4 4-4 4-4-4Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
